import {
  FormFieldController,
  FormFieldControllerRulesProps,
} from '@bambi/component-library/src/components/forms/context/FormFieldController';

import { CoreFormFieldSwitch } from '../core/CoreFormFieldSwitch';

import type { ContextFormFieldBaseProps } from '@bambi/component-library/src/components/forms/context/ContextFormFieldBaseProps';

export const ContextFormFieldSwitch = ({
  fieldPath,
  rules,
  label,
  helperText,
  colSpan,
  disabled,
  passChecked,
}: ContextFormFieldBaseProps & { passChecked?: boolean }) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field }) => (
        <CoreFormFieldSwitch
          inputProps={{ id: fieldPath, ...field, disabled }}
          label={rules?.required ? `${label} *` : label}
          helperText={helperText}
          colSpan={colSpan}
          passChecked={passChecked}
        />
      )}
    </FormFieldController>
  );
};
